/**
 * Check that the passed combination of year month and day constitute a valid date.
 * @param {number} year - An integer representing the year (e.g., 1975).
 * @param {number} month - An integer representing the month (this is zero based as per JavaScript's Date object).
 * @param {number} day - An integer representing the day of the month.
 * @returns {boolean} - true if the combination of year, month, and day represents a valid date according to the calendar, false otherwise.
 */
export function isDateValid(year: number, month: number, day: number) {
    const date = new Date(year, month, day);
    return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
}
